import styled from 'styled-components'

const severityBg = {
  success: 'var(--vo-success-10)',
  error: 'var(--vo-danger-10)',
  warning: 'var(--vo-warning-10)',
  info: 'var(--vo-info-10)',
}

const severityBorder = {
  success: 'var(--vo-success)',
  error: 'var(--vo-danger)',
  warning: 'var(--vo-warning)',
  info: 'var(--color-brand)',
}

export const SnackbarWrapper = styled.div`
  position: fixed;
  top: 84px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1500;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: var(--radius-lg);
  background-color: ${({ $severity }) => severityBg[$severity] || severityBg.info};
  border: 1px solid ${({ $severity }) => severityBorder[$severity] || severityBorder.info};
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  min-width: 300px;
  max-width: 600px;
`

export const Message = styled.span`
  flex: 1;
  font-size: 14px;
  color: var(--vo-ink);
  line-height: 1.4;
`

export const CloseBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  color: var(--vo-slate);
  font-size: 18px;
  line-height: 1;

  &:hover {
    color: var(--vo-ink);
  }
`
